module.exports = __webpack_public_path__ + "img/quality-Inspection.9ccdabd6.png";